import grid from "./components/CvGrid";
import row from "./components/CvRow";
import column from "./components/CvColumn";

const carbonCustomPlugin = {
  install(app) {
    app.component("cv-grid", grid);
    app.component("cv-row", row);
    app.component("cv-column", column);
  },
};

export default carbonCustomPlugin;
